<template>
  <div class="serviceWarp">
    <div class="bananerArea">
      <div class="bananerBox">
        <div class="infoBox">
          <h3>专业<span>服务</span></h3>
          <h4 style="width: 835px;">{{titleDesc}}</h4>
          <ul>
            <li v-for="item in descList" :key="`desc${item.title}`">{{ item.title }}<span>{{ item.desc }}</span></li>
          </ul>
        </div>
        <div class="btnBox">
          <div class="iptBox" @click="handleOperateClick">
            {{ String(isInner) === '1' ? '线索登记' : '我要咨询' }}<span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="hotArea" v-show="hotList.length > 0">
      <div class="hotList" >
        <div class="list" v-for="(item, index) in hotList" :key="`hot${index}`" @click="goDetail(item);" >
          <div class="name">
            <img class="logo" :src="item.logo">
            <div class="tx">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="productArea" ref="mainContent">
      <div class="pro-anchor leftmenu-list-wrap" :style="suspensionStyle" >
        <ul class="list">
          <li v-for="(item, index) in allProductList" :key="`nav${index}`"
              class="hover-menu"
              :class="{active: activeMenuIndex == index }"
              @click="goAnchor(index)" > {{item.title}}</li>
        </ul>
      </div>
      <div class="classify-container" id="classifyContainer">
        <div class="classifyList" v-for="(items, indexs) in allProductList" :key="`items${indexs}`" >
          <h4 :id="`anchor_${items.id}`" class="module-anchor" >{{items.title}}</h4>
          <div class="list" v-for="(item, index) in items.children" :key="`item${index}`"  @click="goDetail(item);" >
            <div class="name">
              <img :src="items.logo"/>
              {{item.title}}</div>
            <div class="info">{{item.desc}}</div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <connectUplus />

    <!--  bussType:1-产品, 2-行业解决方案  -->
    <!--  sourceType:product-产品, module-模块, solution-解决方案 -->
    <compSeekAdvice ref="seekAdviceFrom"></compSeekAdvice>
    <compCheckIn ref="checkInFrom"></compCheckIn>
  </div>
</template>
<script>
import axios from "axios";
import scrollMixin from '../productSolution/scrollMixin.js'
import {mapGetters} from "vuex";
const { compCheckIn, compSeekAdvice } = window['openplat-header'].default

export default {
  data() {
    return {
      hotList: [],
      allProductList: [],
      anchor:  {
        isFix: false,
        isAbsolute: false
      },
      activeIndex: 0,
      titleDesc: '',
      descList: []
    }
  },
  components: {compSeekAdvice, compCheckIn},
  watch: {},
  computed: {
    ...mapGetters(['uPlusUser']),
    // 1:内部，0:外部/游客
    isInner() {
      return this.uPlusUser ? this.uPlusUser.isInner : ''
    }
  },
  created () {
    this.activeIndex = this.$route.query.navbar
  },
  mounted () {
    this.getHomeJson()
  },
  beforeDestroy () {},
  mixins: [scrollMixin],
  methods: {
    setGio(index, item,clickArea,business_area) {
      try {
        this.gioTrackEvent("USoln_clickSolution", {
          serialNumber_var: index + 1,
          clickArea_var:clickArea,
          solnCategorySelected_var:business_area,
          M_solutionId_var: item.solution_id,
          isHot_var:item.hot_flag=='1'?'Hot':''
        });
      } catch (e) {
        console.log(e);
      }
    },
    goDetail (item) {
      if (item.link) {
        window.open(item.link)
      } else {
        this.$hMessage.warning({
          content: '敬请期待'
        })
      }
    },
    setGioClick(name){
        this.gioTrackEvent("USoln_clickInDetailPage",{
         clickButtonName_var:name
        });
    },
    // 处理线索登记或者我要咨询点击
    handleOperateClick() {
      if (this.uPlusUser.authId) {
        if (String(this.isInner) === '1') {
          // this.setGioClick('线索登记');
          // this.gioTrackEvent("U_maketClickBusinessOpportunity",{
          //   appId_var: 101,
          //   M_productId_var:'',
          //   M_productName_var:'',
          //   M_solutionId_var:'',
          //   M_solutionName_var:'',
          //   M_productModuleId_var:'',
          //   M_productModuleName_var:''
          // });
          this.$refs.checkInFrom.openCheckIn()
        } else {
          // this.setGioClick('我要咨询');
          // this.gioTrackEvent("U_maketClickConsult",{
          //   appId_var: 101,
          //   M_productId_var:'',
          //   M_productName_var:'',
          //   M_solutionId_var:'',
          //   M_solutionName_var:'',
          //   M_productModuleId_var:'',
          //   M_productModuleName_var:''
          // });
          this.$refs.seekAdviceFrom.openSeekAdvice()
        }
      } else {
        localStorage.setItem('backUrl', window.location.href)
        this.$goLoginUrl()
      }
    },
    getHomeJson() {
      axios
        .get(
          "/r/cms/www/openplatWeb/serviceJSON/home.json?timestamp="+Math.round(new Date().getTime()/(1000*60*10))
        )
        .then(res => {
          const jsonData = res.data || {}
          this.hotList = jsonData.hotService
          this.allProductList = jsonData.allService
          this.titleDesc = jsonData.titleDesc
          this.descList = jsonData.descList
          this.$nextTick(() => {
            this.genModuleTops(this.activeIndex) // scrollMixin中的方法
          })
        });
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../productSolution/main.scss";
.serviceWarp {
  background-color: #F7F8FF;
  .bananerArea .bananerBox {
    .infoBox {
      padding-top: 54px;
      h3 {
        span {
          color: #004CFF;
        }
      }
      h4 {
        padding-top: 10px;
        font-size: 16px;
        text-indent: 32px;
      }
      ul {
        padding-left: 32px;
        li {
          font-size: 14px;
          color: #333;
          padding: 3px 0;
          display: flex;
          align-items: center;
          >span {
            color: #666;
          }
          &::before {
            content: '';
            width: 4px;
            height: 4px;
            display: inline-block;
            background-color: #004CFF;
            border-radius: 4px;
            margin-right: 14px;
          }
        }
      }
    }
    .btnBox {
      padding-top: 30px;
      padding-left: 72px;
    }
  }
}
.hotArea{
  margin: 20px auto 0;
  width: 1280px;
  h3{
    font-size: 26px;
    color: #333333;
    line-height: 26px;
    font-weight: 500;
    padding: 30px 20px 20px;
  }
  .hotList{
    @include setFlexDisplay(row, flex-start);
    flex-flow: row wrap;
    
    .list{
      background: #FFFFFF;
      width: 20%;
      height: 142px;
      margin: 0 2.5% 20px;
      border: 1px solid rgba(241,242,249,1);
      box-shadow: 0px 2px 17px 0px rgba(219,231,249,0.7);
      border-radius: 4px;
      &:hover{
        cursor: pointer;
        box-shadow: 0 0 10px rgba(0,0,0,0.2);
        .name .tx {
          color: #004cff;
        }
      }
    }
    .name{
      text-align: center;
      height: 100%;
      @include setFlexDisplay(column, center, center);
      .logo {
        width: 66px;
      }
      .tx {
        font-weight: bold;
        text-overflow:ellipsis;
        white-space:nowrap;
        overflow: hidden;
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: 600;
        padding-bottom: 10px;
      }
    }
    .info{
      padding-top: 7px;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      line-height: 22px;
      height: 32px;
      overflow: hidden;
    }
  }
}
.productArea{
  margin: 20px auto 0;
  width: 1280px;
  position: relative;
  .pro-wrapper {
    display: flex;
    max-width: 1280px;
    margin:0 auto;
    background-color: white;
  }
  .pro-anchor {
    width: 240px;
    padding-left: 20px;
    text-align: center;
    position: absolute;
    ul.list {
      padding-top: 14px;
      li{
        cursor: pointer;
        line-height: 40px;
        font-size: 14px;
        font-weight: 500;
        &.active {
          color: #004cff;
          background-color: #E9EFFF
        }
      }
    }
    &.fix{
      position: fixed;
      top: 0;
    }
    &.bottom{
      bottom: 0
    }
  }
  .classify-container {
    flex: 1;
    padding: 0 0 0 40px;
    margin-left: 240px;
    min-height: 500px;
    border-left: 1px solid #d7dde4;
    overflow: hidden;
    .classifyList{
      padding-bottom: 20px;
      overflow: hidden;
      h4 {
        font-family: PingFangSC-Medium;
        font-size: 26px;
        color: #333333;
        line-height: 30px;
        font-weight: 500;
        height: 30px;
        margin-bottom: 20px;
        clear: both;
      }
    }
    .list {
      width: 300px;
      height: 128px;
      float: left;
      padding: 15px 24px;
      position: relative;
      background: #FFFFFF;
      margin-bottom: 20px;
      margin-right: 32px;
      border: 1px solid rgba(241,242,249,1);
      box-shadow: 0px 2px 17px 0px rgba(219,231,249,0.7);
      border-radius: 4px;
      &:hover {
        cursor: pointer;
        box-shadow: 0 5px 10px rgba(0,0,0,0.2);
        .name {
          color: #004CFF;
        }
      }

      .purchased {
        font-size: 12px;
        position: absolute;
        right: 10px;
        bottom: 10px;
        color: white;
        background: #A8A7C6;
        padding: 2px 5px;
      }

      .name {
        font-size: 18px;
        color: #333333;
        line-height: 35px;
        font-weight: 500;
        height: 35px;
        overflow: hidden;
        >img {
          width: 35px;
          vertical-align: middle;
        }
        .tx {
          display: -webkit-box;
          overflow: hidden;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
        }
      }
      .info {
        padding-top: 6px;
        font-size: 13px;
        color: #666666;
        letter-spacing: 0;
        line-height: 22px;
        overflow: hidden;
      }
      .from {
        color: #999999;
        .dot {
          padding: 0 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/uPlus/service.vue